import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import {
  startPreparation,
  checkStatuses,
  setPage,
  loadPage,
  initMonitoring,
  startMonitoring,
  stopMonitoring,
} from './types';
import { AppDispatch, RootState } from 'store';
import { PAGE_SIZE } from '.';

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Custom hook for document preparation
export const useDocumentPreparation = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.documentPreparationReducer);

  const startDocumentPreparation = () => {
    dispatch(startPreparation());
  };

  const checkStatusesNow = () => {
    dispatch(checkStatuses());
  };

  const setCurrentPage = (page: number) => {
    dispatch(setPage(page));
  };

  const loadSpecificPage = (page: number) => {
    dispatch(loadPage(page));
  };

  const initMonitoringNow = () => {
    dispatch(initMonitoring());
  };

  const startMonitoringNow = () => {
    dispatch(startMonitoring());
  };

  const stopMonitoringNow = () => {
    dispatch(stopMonitoring());
  };

  return {
    // State
    isCreatingReports: state.isCreatingReports,
    isLoading: state.isLoading,
    isInit: state.isInit,
    isDisabledGenerateBtn: state.isDisabledGenerateBtn,
    data: state.data,
    pagination: state.pagination,
    pageSize: PAGE_SIZE,
    error: state.error,
    
    // Actions
    startDocumentPreparation,
    checkStatusesNow,
    setCurrentPage,
    loadSpecificPage,
    initMonitoringNow,
    startMonitoringNow,
    stopMonitoringNow,
  };
};
